const EnterBar = () => import(/* webpackChunkName:"chunk-actbar" */ '../views/P5_Activitys/ActEnterBar/index.vue')

const BeerAct = () => import(/* webpackChunkName:"chunk-beeract" */ '../views/P5_Activitys/BeerCollect')

const CallMotivation = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/index.vue')
const CallMotivationRules = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/rules.vue')

// 动态页面容器
const DyPage = () => import(/* webpackChunkName:"chunk-dypage" */ '../views/P5_Activitys/DyPage/index.vue')

const Incentive = () => import(/* webpackChunkName:"chunk-incentive" */ '../views/P5_Activitys/Incentive/index.vue')
const IncentiveForNew = () => import(/* webpackChunkName:"chunk-incentivefornew" */ '../views/P5_Activitys/IncentiveForNew/index.vue')

const InviteEarn = () => import(/* webpackChunkName:"chunk-inviteearn" */ '../views/P5_Activitys/InviteEarn/index.vue')

const Liveness = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/index.vue')
const LivenessRules = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/rules.vue')

const MatchingToPay = () => import(/* webpackChunkName:"chunk-matchingtopay" */ '../views/P5_Activitys/MatchingToPay/index.vue')

const NewguyWheelPan = () => import(/* webpackChunkName:"chunk-NewguyWheelPan" */ '../views/P5_Activitys/NewguyWheelPan/index.vue')
const NewguyWheelPanRules = () => import(/* webpackChunkName:"chunk-NewguyWheelPan" */ '../views/P5_Activitys/NewguyWheelPan/rules.vue')

const NineDotNinetyNine = () => import(/* webpackChunkName:"chunk-NineDotNinetyNine" */ '../views/P5_Activitys/NineDotNinetyNine/index.vue')

const NineteenDotNinetyNine = () => import(/* webpackChunkName:"chunk-NineteenDotNinetyNine" */ '../views/P5_Activitys/NineteenDotNinetyNine/index.vue')

const PrivateCallIncome = () => import(/* webpackChunkName:"chunk-privatecall" */ '../views/P5_Activitys/PrivateCallIncome')

const RechargeAfterFirst = () => import(/* webpackChunkName:"chunk-rechargeAfterFirst" */ '../views/P5_Activitys/RechargeAfterFirst/index.vue')

const RechargeFirst = () => import(/* webpackChunkName:"chunk-rechargefirst" */ '../views/P5_Activitys/RechargeFirst/index.vue')

const RechargeLowSmall = () => import(/* webpackChunkName:"chunk-rechargeLowSmall" */ '../views/P5_Activitys/RechargeLowSmall/index.vue')

const RechargeMidR = () => import(/* webpackChunkName:"chunk-rechargeMidR" */ '../views/P5_Activitys/RechargeRUser/midR.vue')
const RechargeTopR = () => import(/* webpackChunkName:"chunk-rechargeTopR" */ '../views/P5_Activitys/RechargeRUser/topR.vue')

const Repurchase = () => import(/* webpackChunkName:"chunk-repurchase" */ '../views/P5_Activitys/Repurchase/index.vue')

const SubAgentEvent = () => import(/* webpackChunkName:"chunk-subagentevent" */ '../views/P5_Activitys/SubAgentEvent/index.vue')

const ActMexicoMainFemale = () => import(/* webpackChunkName:"chunk-actmexico" */ '../views/P5_Activitys/ActMexico/actFemaleMain.vue')
const ActMexicoRankFemale = () => import(/* webpackChunkName:"chunk-actmexico" */ '../views/P5_Activitys/ActMexico/actFemaleRank.vue')
const ActMexicoRulesFemale = () => import(/* webpackChunkName:"chunk-actmexico" */ '../views/P5_Activitys/ActMexico/actFemaleRules.vue')
const ActMexicoMainMale = () => import(/* webpackChunkName:"chunk-actmexico" */ '../views/P5_Activitys/ActMexico/actMaleMain.vue')
const ActMexicoRecordsMale = () => import(/* webpackChunkName:"chunk-actmexico" */ '../views/P5_Activitys/ActMexico/actMaleRecords.vue')
const ActMexicoRulesMale = () => import(/* webpackChunkName:"chunk-actmexico" */ '../views/P5_Activitys/ActMexico/actMaleRules.vue')

const ActMidEastMainFemale = () => import(/* webpackChunkName:"chunk-actmideast" */ '../views/P5_Activitys/ActMidEast/actFemaleMain.vue')
const ActMidEastRankFemale = () => import(/* webpackChunkName:"chunk-actmideast" */ '../views/P5_Activitys/ActMidEast/actFemaleRank.vue')
const ActMidEastRulesFemale = () => import(/* webpackChunkName:"chunk-actmideast" */ '../views/P5_Activitys/ActMidEast/actFemaleRules.vue')
const ActMidEastMainMale = () => import(/* webpackChunkName:"chunk-actmideast" */ '../views/P5_Activitys/ActMidEast/actMaleMain.vue')
const ActMidEastRecordsMale = () => import(/* webpackChunkName:"chunk-actmideast" */ '../views/P5_Activitys/ActMidEast/actMaleRecords.vue')
const ActMidEastRulesMale = () => import(/* webpackChunkName:"chunk-actmideast" */ '../views/P5_Activitys/ActMidEast/actMaleRules.vue')

const routes = [
  // 运营位
  {
    path: '/act-enter', name: 'act-enter', component: EnterBar, meta: { hideVConsole: true }
  },
  // 啤酒收集节
  {
    path: '/beer-collect', name: 'beer-collect', component: BeerAct
  },
  // 男用户通话激励
  {
    path: '/call-motivation', name: 'call-motivation', component: CallMotivation
  },
  {
    path: '/call-motivation-rules', name: 'call-motivation-rules', component: CallMotivationRules
  },

  // 自定义图片页面
  {
    path: '/dy-page/:customPageId', name: 'dy-page', component: DyPage
  },
  // 激励活动
  {
    path: '/incentive-act', name: 'incentive-act', component: Incentive
  },
  // 新用户激励活动
  {
    path: '/incentive-fornew', name: 'incentive-fornew', component: IncentiveForNew
  },
  // 分享裂变
  {
    path: '/invite-earn', name: 'invite-earn', component: InviteEarn
  },
  // 升级奖励
  {
    path: '/liveness', name: 'liveness', component: Liveness
  },
  {
    path: '/liveness-rules', name: 'liveness-rules', component: LivenessRules
  },
  // match
  {
    path: '/matching-to-pay', name: 'matching-to-pay', component: MatchingToPay
  },
  // 新用户转盘
  {
    path: '/newguy-wheel-pan', name: 'newguy-wheel-pan', component: NewguyWheelPan
  },
  {
    path: '/newguy-wheel-pan-rules', name: 'newguy-wheel-pan-rules', component: NewguyWheelPanRules
  },
  // 充值活动9.99
  {
    path: '/recharge-ninepointninety', name: 'nine-dot-ninetynine', component: NineDotNinetyNine
  },
  // 充值活动19.99
  {
    path: '/nineteen-ninety_nine', name: 'nineteen-dot-ninetynine', component: NineteenDotNinetyNine
  },
  // 主播限时付费电话补贴
  {
    path: '/private-call-income', name: 'private-call-income', component: PrivateCallIncome
  },
  // 充值-次充
  {
    path: '/recharge-afterfirst', name: 'recharge-afterfirst', component: RechargeAfterFirst
  },
  // 充值-首充
  {
    path: '/recharge-first', name: 'recharge-first', component: RechargeFirst
  },
  // 低频小额用户充值
  {
    path: '/recharge-low-small', name: 'recharge-low-small', component: RechargeLowSmall
  },
  // 中小R用户充值
  {
    path: '/recharge-mid-r', name: 'recharge-mid-r', component: RechargeMidR
  },
  // 大R用户充值
  {
    path: '/recharge-top-r', name: 'recharge-top-r', component: RechargeTopR
  },
  // 复购
  {
    path: '/repurchase', name: 'repurchase', component: Repurchase
  },
  // 二级代理活动
  {
    path: '/sub-agent-event', name: 'sub-agent-event', component: SubAgentEvent
  },
  // 墨西哥活动（女用户）
  {
    path: '/act-mexico-female-main', name: 'act-mexico-female-main', component: ActMexicoMainFemale
  },
  {
    path: '/act-mexico-female-rank', name: 'act-mexico-female-rank', component: ActMexicoRankFemale
  },
  {
    path: '/act-mexico-female-rules', name: 'act-mexico-female-rules', component: ActMexicoRulesFemale
  },
  // 墨西哥活动（男用户）
  {
    path: '/act-mexico-male-main', name: 'act-mexico-male-main', component: ActMexicoMainMale, meta: { keepAlive: true }
  },
  {
    path: '/act-mexico-male-records', name: 'act-mexico-male-records', component: ActMexicoRecordsMale
  },
  {
    path: '/act-mexico-male-rules', name: 'act-mexico-male-rules', component: ActMexicoRulesMale
  },
  // 中东嘉年华（女用户）
  {
    path: '/act-midEast-female-main', name: 'act-midEast-female-main', component: ActMidEastMainFemale
  },
  {
    path: '/act-midEast-female-rank', name: 'act-midEast-female-rank', component: ActMidEastRankFemale
  },
  {
    path: '/act-midEast-female-rules', name: 'act-midEast-female-rules', component: ActMidEastRulesFemale
  },
  // 中东嘉年华（男用户）
  {
    path: '/act-midEast-male-main', name: 'act-midEast-male-main', component: ActMidEastMainMale, meta: { keepAlive: true }
  },
  {
    path: '/act-midEast-male-records', name: 'act-midEast-male-records', component: ActMidEastRecordsMale
  },
  {
    path: '/act-midEast-male-rules', name: 'act-midEast-male-rules', component: ActMidEastRulesMale
  }
]
export default routes
